import { GenericResource, IHttpAgent, IListResponse } from '@sparelabs/http-client-utils'
import {
  IRouteOptimizationGlobalOptimizationRequest,
  IRouteOptimizationGlobalOptimizationResponse,
  IRouteOptimizationListMatchingOutcomesQueryParams,
  IRouteOptimizationMatchBreakRequest,
  IRouteOptimizationMatchBreakResponse,
  IRouteOptimizationMatchingOutcome,
  IRouteOptimizationMatchRequestRequest,
  IRouteOptimizationMatchRequestResponse,
  IRouteOptimizationModifyDutyRequest,
  IRouteOptimizationModifyDutyResponse,
  IRouteOptimizationOptimizeDutyRequest,
  IRouteOptimizationOptimizeDutyResponse,
  Resources,
} from '../types'

// ROS is more RPC than REST, so we don't use the core REST helpers in GenericResource
export class RouteOptimizationResource extends GenericResource<never, never, never, never> {
  constructor(agent: IHttpAgent) {
    super(Resources.RouteOptimization, agent)
  }

  public async globallyOptimize(
    body: IRouteOptimizationGlobalOptimizationRequest,
  ): Promise<IRouteOptimizationGlobalOptimizationResponse> {
    return (
      await this.agent.post<IRouteOptimizationGlobalOptimizationResponse>(`${this.resource}/globallyOptimize`, body)
    ).data
  }

  public async matchRequest(
    body: IRouteOptimizationMatchRequestRequest,
  ): Promise<IRouteOptimizationMatchRequestResponse> {
    return (await this.agent.post<IRouteOptimizationMatchRequestResponse>(`${this.resource}/matchRequest`, body)).data
  }

  public async optimizeDuty(
    body: IRouteOptimizationOptimizeDutyRequest,
  ): Promise<IRouteOptimizationOptimizeDutyResponse> {
    return (await this.agent.post<IRouteOptimizationOptimizeDutyResponse>(`${this.resource}/optimizeDuty`, body)).data
  }

  public async modifyDuty(body: IRouteOptimizationModifyDutyRequest): Promise<IRouteOptimizationModifyDutyResponse> {
    return (await this.agent.post<IRouteOptimizationModifyDutyResponse>(`${this.resource}/modifyDuty`, body)).data
  }

  public async matchBreak(body: IRouteOptimizationMatchBreakRequest): Promise<IRouteOptimizationMatchBreakResponse> {
    return (await this.agent.post<IRouteOptimizationMatchBreakResponse>(`${this.resource}/matchBreak`, body)).data
  }

  public async listMatchingOutcomes(
    params: IRouteOptimizationListMatchingOutcomesQueryParams,
    fetchAllPages: boolean = false,
  ): Promise<IListResponse<IRouteOptimizationMatchingOutcome>> {
    if (fetchAllPages) {
      const data = await this.allPageFetcher.fetch<
        IRouteOptimizationMatchingOutcome,
        IRouteOptimizationListMatchingOutcomesQueryParams
      >(`${this.resource}/matchingOutcomes`, params)
      return { data, skip: 0, total: data.length, limit: data.length }
    }

    return (
      await this.agent.get<IListResponse<IRouteOptimizationMatchingOutcome>>(`${this.resource}/matchingOutcomes`, {
        params,
      })
    ).data
  }
}
